import React from 'react'
import { get } from 'lodash'
import {
  AppBar,
  Hidden,
  Container,
  Toolbar,
  useTheme,
  Box,
} from '@material-ui/core'

import { isAdminPathname } from 'utils/helpers'
import SearchField from 'ui/header/SearchField'
import Logo from 'ui/Logo'
import useCurrentUser from 'auth/useCurrentUser'
import AppBarMenu from './AppBarMenu'

const AppBarContainer = ({ sidebar, children }) =>
  sidebar ? (
    <Box px={3}>{children}</Box>
  ) : (
    <Container maxWidth="md" style={{ padding: '0 10px' }}>
      {children}
    </Container>
  )

const CustomAppBar = ({
  location,
  hideDetails = false,
  showSidebar = false,
}) => {
  const theme = useTheme()
  const [{ currentUser }] = useCurrentUser()

  const userType = get(currentUser, 'userType')
  const userCategory = get(currentUser, 'category')
  const appBarHeight = theme.spacing(10)

  return (
    <AppBar
      css={{
        maxWidth: '100vw',
        zIndex: hideDetails ? 10000 : theme.zIndex.drawer + 2,
      }}
      position="fixed"
      elevation={0}
    >
      <AppBarContainer sidebar={showSidebar}>
        <Toolbar
          style={{
            padding: 0,
            height: appBarHeight,
            justifyContent: 'space-between',
          }}
        >
          <Logo />

          {!isAdminPathname(location.pathname) && !hideDetails && (
            <Hidden smDown>
              <SearchField />
            </Hidden>
          )}

          {!hideDetails && (
            <AppBarMenu
              appBarHeight={appBarHeight}
              sidebar={showSidebar}
              userType={userType}
              userCategory={userCategory}
            />
          )}
        </Toolbar>
      </AppBarContainer>
    </AppBar>
  )
}

export default CustomAppBar
